/**
 * Stable CSS class names for E2E — ShippingCompanyLabel page.
 * Containers use `shipping-company-label__<element>`; inputs and
 * user-interactable controls use `shipping-company-label-input--<name>`.
 */
export const SCL = {
    page: 'shipping-company-label-page',
    root: 'shipping-company-label',

    inner: 'shipping-company-label__inner',
    confetti: 'shipping-company-label__confetti',
    breadcrumb: 'shipping-company-label__breadcrumb',

    searchForm: 'shipping-company-label__search-form',
    searchBox: 'shipping-company-label__search-box',
    inputShippingNo: 'shipping-company-label-input--shipping-no',
    btnSearch: 'shipping-company-label-input--button-search',

    loading: 'shipping-company-label__loading',

    preview: 'shipping-company-label__preview',
    previewBody: 'shipping-company-label__preview-body',
    btnDownload: 'shipping-company-label-input--button-download',
    previewIframe: 'shipping-company-label__preview-iframe',
} as const;

export const sclCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
